import api from '../../services/api';
import { Creators } from '../ducks/tenant_config';
import { call, put } from 'redux-saga/effects';
import { actions as toastrActions } from 'react-redux-toastr';
import { captureSentryException } from '../../utils';

export function* getTenantConfig() {
  try {
    let response;

    yield put(Creators.tenantConfigRequest());
    response = yield call(api.get, 'tenant-config');

    yield put(Creators.tenantConfigSuccess(response.data));
  } catch (err) {
    yield captureSentryException(err, null);
    yield put(Creators.tenantConfigError({ err }));
    yield put(toastrActions.add({
      type: 'error',
      title: 'Erro',
      message: 'Falha ao buscar configurações da filial'
    }));
  }
}